import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M11 9l0 .01","key":"svg-1"}],["path",{"d":"M15 8l0 .01","key":"svg-2"}],["path",{"d":"M14 12l0 .01","key":"svg-3"}]]

const IconBallBowling = createReactComponent('outline', 'ball-bowling', 'BallBowling', __iconNode);

export default IconBallBowling;